import React, { useEffect, useState } from 'react'
import { Trophy } from 'lucide-react'

export interface NewBadge {
  slug: string
  name: string
  icon: string
}

interface BadgeToastProps {
  badges: NewBadge[]
  onDone: () => void
}

export default function BadgeToast({ badges, onDone }: BadgeToastProps) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    // Delay appearance so it doesn't overlap with confetti
    const showTimer = setTimeout(() => setVisible(true), 1500)
    const hideTimer = setTimeout(() => {
      setVisible(false)
      setTimeout(onDone, 500)
    }, 5500)
    return () => { clearTimeout(showTimer); clearTimeout(hideTimer) }
  }, [onDone])

  if (badges.length === 0) return null

  return (
    <div className={`fixed top-20 right-6 z-50 transition-all duration-500 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'}`}>
      <div className="w-72 rounded-xl border border-amber-200 bg-gradient-to-br from-amber-50 to-white shadow-xl overflow-hidden">
        <div className="px-4 py-3 flex items-center gap-3 border-b border-amber-100">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gradient-to-br from-amber-400 to-orange-500 shadow-sm">
            <Trophy className="h-4 w-4 text-white" />
          </div>
          <div>
            <p className="text-xs font-bold text-amber-900">
              {badges.length === 1 ? 'Badge Unlocked!' : `${badges.length} Badges Unlocked!`}
            </p>
          </div>
        </div>
        <div className="px-4 py-3 space-y-2">
          {badges.map((badge) => (
            <div key={badge.slug} className="flex items-center gap-3">
              <img
                src={`/illustrations/badges/${badge.icon}.svg`}
                alt={badge.name}
                className="h-8 w-8 shrink-0"
              />
              <span className="text-sm font-semibold text-slate-800">{badge.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
